<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';

const props = defineProps<{
    isShow: number | boolean,
    language: string,
    keywordStr: string | undefined,
    keywordUrl: string | undefined,
}>();
const chatStore = useChatStore();

</script>

<template>
    <div v-if="props.isShow" :class="chatStore.createLanguageClass(props.language)">
        <div class="flex flex-col min-w-[240px] w-fit text-sm my-2">
            <a :href="props.keywordUrl"
                class="flex items-center justify-center font-lang-ja border border-design-red rounded-sm bg-design-pink"
                target="_blank">
                <div class="bg-design-pink px-2">
                    <Icon name="material-symbols:search" size="18px" />
                </div>
                <div class="bg-white px-2 py-1 grow hover:bg-design-pink">{{ props.keywordStr }}</div>
            </a>
        </div>
    </div>
</template>